import { Menu, MenuItem } from '@mui/material';
import { setTransportSelectedItemConditionOptions } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTransportTrackIntervalMenu = (props) => {
  const dispatch = useDispatch();
  const { conditionOptions } = useSelector((state) => state.map.transportSelectedItem);
  const { open, onClose, anchorEl } = props;

  const formatInterval = (hour) => {
    moment.relativeTimeThreshold('h', 25);
    return `${hour > 1 ? '' : '1 '}${moment.duration(hour, 'hours').humanize()}`;
  };

  const handleTrackIntervalClick = (value) => {
    dispatch(
      setTransportSelectedItemConditionOptions({
        ...conditionOptions,
        interval: value,
      })
    );

    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: '140px',
          marginTop: '1px',
          '&:before': {
            display: 'none',
          },
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}>
      {config.mapTransportTrackInterval.map((value, key) => (
        <MenuItem key={key} disableRipple selected={conditionOptions.interval === value} onClick={() => handleTrackIntervalClick(value)}>
          {formatInterval(value)}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default MapTransportTrackIntervalMenu;
